<template lang="pug">
v-autocomplete(
  v-bind='$attrs'
  v-bind.props='$props'
  @input='$emit("input", $event)'
  :items='list'
  item-value='id'
  item-text='layout_name'
  :item-avatar='getItemAvatar'
)
  template(v-slot:item="data")
    v-list-tile-content
      v-list-tile-title(v-html="data.item.layout_name")
    v-tooltip(
      left,
      open-delay=0,
      close-delay=0,
      content-class="hover-tooltip",
      class="avatar-tooltip"
      v-if='hasAvatar(data.item)',
    )
      v-list-tile-avatar(tile slot="activator")
        v-img(
          :src='getItemAvatar(data.item)',
          :lazy-src='getItemAvatar(data.item)',
          class='grey lighten-4 thumb sm-avatar'
        )
          v-layout(slot='placeholder' fill-height align-center justify-center ma-0)
            v-progress-circular(indeterminate color='primary' :size='24')
      div(class="hover-preview")
        img(:src="getItemAvatar(data.item)")
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import picker from '@/mixins/picker';
import { ThumbService } from '@/services/ThumbService'

export default {
  mixins: [picker],

  props: {
    label: {
      default: 'Выберите планировку'
    },
    objectId: null,
    filter: null
  },

  created() {
    this.fetch({ object_id: this.objectId });
  },

  methods: {
    hasAvatar(props) {
      const avatar = this.getItemAvatar(props)
      return avatar !== undefined
    },

    getItemAvatar(props) {
      const images = [props.placement_sizing_url, props.render_view_url, props.render_plan_url,  props.placement_scheme_url]
      let imageSrc = images.find(i => i !== null)
      if (imageSrc !== undefined) {
        imageSrc = ThumbService.getThumbUrl({
          url: imageSrc,
          preload: true,
          width: 400,
        })
      }
      return imageSrc
    },

    ...mapActions('dictionary/layouts', ['fetch'])
  },

  computed: mapGetters('dictionary/layouts', ['list'])
};
</script>


<style scoped>
.hover-preview {
  overflow: hidden;
  aspect-ratio: 1;
  width: 25vw;
  background: white;
  position: relative;
}
.hover-preview img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.hover-tooltip {
  background: white;
  box-shadow: none;
  /* opacity: 1 !important; */
}
.sm-avatar {
  display: block;
}
.avatar-tooltip {
  width: 40px;
  height: 40px;
  margin-left: 8px;
}
</style>